import React from "react";
import {
  getSuccessfulPayments,
} from "../paymentCalculations";

export const PaymentStatusSummarySection = ({ formData }) => (
  <div className="summary-section">
    <h4>Payment Status</h4>

    {formData.paid || getSuccessfulPayments(formData.payment).length > 0 ? (
      <div className="payment-status completed">
        <span className="status-icon">✅</span>
        <span className="status-text">
          Payment completed and registration confirmed
        </span>
      </div>
    ) : (
      <div className="payment-status pending">
        <span className="status-icon">⏳</span>
        <span className="status-text">
          Payment pending - Please complete payment to confirm registration
        </span>
      </div>
    )}
  </div>
);
